import cloneDeep from "lodash.clonedeep";
import type { PiniaPluginContext } from 'pinia' // ✅ apenas no TypeScript

function resetStore({ store }: PiniaPluginContext): void {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => store.$patch(cloneDeep(initialState));
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(resetStore);
});
